import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import {
  getAnchorPlugin,
  waitForMilliseconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

import UIBlocker from '../prefabs/GeneralUI/UIBlocker';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class MobileOverlay extends Phaser.Scene {
  constructor() {
    super('MobileOverlay');

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // mobileOrientationModal
    const mobileOrientationModal = this.add.container(0, 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(this, 0, 0);
    mobileOrientationModal.add(uIBlocker);

    // mainContainer
    const mainContainer = this.add.container(0, 0);
    mobileOrientationModal.add(mainContainer);

    // mainBacking
    const mainBacking = this.add.nineslice(
      0,
      0,
      'Hud1',
      undefined,
      92,
      64,
      10,
      10,
      10,
      10,
    );
    mainBacking.scaleX = 4;
    mainBacking.scaleY = 4;
    mainContainer.add(mainBacking);

    // orientationText_1
    const orientationText_1 = this.add.bitmapText(
      0,
      64,
      'Aronui',
      'Please switch your device to landscape mode to continue playing',
    );
    orientationText_1.setOrigin(0.5, 0.5);
    orientationText_1.tintTopLeft = 5387071;
    orientationText_1.tintTopRight = 5387071;
    orientationText_1.tintBottomLeft = 5387071;
    orientationText_1.tintBottomRight = 5387071;
    orientationText_1.text =
      'Please switch your device to landscape mode to continue playing';
    orientationText_1.fontSize = -14;
    orientationText_1.align = 1;
    orientationText_1.maxWidth = 300;
    mainContainer.add(orientationText_1);

    // mobileLandscapeImage
    const mobileLandscapeImage = this.add.image(
      20,
      -20,
      'phone-landscape-mode',
    );
    mobileLandscapeImage.scaleX = 4;
    mobileLandscapeImage.scaleY = 4;
    mobileLandscapeImage.tintTopLeft = 5387071;
    mobileLandscapeImage.tintTopRight = 5387071;
    mobileLandscapeImage.tintBottomLeft = 5387071;
    mobileLandscapeImage.tintBottomRight = 5387071;
    mainContainer.add(mobileLandscapeImage);

    this.orientationText_1 = orientationText_1;
    this.mainContainer = mainContainer;
    this.mobileOrientationModal = mobileOrientationModal;

    this.events.emit('scene-awake');
  }

  private orientationText_1!: Phaser.GameObjects.BitmapText;
  private mainContainer!: Phaser.GameObjects.Container;
  private mobileOrientationModal!: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  update() {
    const currentView = ResponsivenessManager.GetCurrentGlobalViewForGame(this);
    const currentDimensionRatio =
      this.game.scale.width / this.game.scale.height;
    const isLogin = getSceneManager()?.activeSceneKey === 'Login';
    const _shouldShowOrientationModal = isLogin
      ? currentView === 'mobile' && currentDimensionRatio > 1
      : currentView === 'mobile' && currentDimensionRatio < 1;

    const desiredOrientation = isLogin ? 'portrait' : 'landscape';
    const orientationText = `Please switch your device to ${desiredOrientation} mode to continue playing`;

    this.mobileOrientationModal.setVisible(false); // Temporarily disable the overlay.
    this.orientationText_1.setText(orientationText);
    // Ensure this scene is always rendered on top.
    this.scene.bringToTop();
  }

  create() {
    this.editorCreate();
    this.initializeResponsiveness();

    this.input.on('pointerup', () => this.handlePointerUp());
    window.addEventListener('orientationchange', () =>
      this.handleOrientationChanged(),
    );
    this.scale.on('resize', this.handleResize, this);
    this.handleResize({
      width: this.game.scale.width,
      height: this.game.scale.height,
    });
  }

  async initializeResponsiveness() {
    await waitForMilliseconds(this.time, 1);

    const anchor = getAnchorPlugin(this);
    anchor.add(this.mainContainer, {
      centerX: '50%',
      centerY: '50%',
    });
  }

  handlePointerUp() {
    // Temp disable fullscreen. Maybe bring back one day.
    // const isLogin = getSceneManager()?.activeSceneKey === 'Login';
    // if (ResponsivenessManager.IsMobileDevice(this) && !isLogin) {
    //   this.scale.startFullscreen();
    // }
  }

  handleResize(gameSize: any) {
    const width = gameSize.width;
    const height = gameSize.height;
    this.cameras.resize(width, height);
  }

  async handleOrientationChanged() {
    // Wait for browser to settle
    await waitForMilliseconds(this.time, 300);

    const width = window.innerWidth;
    const height = window.innerHeight;

    // Force Phaser to adopt the new dimensions
    this.game.scale.resize(width, height);

    // Double-tap after another delay in case the browser wasn't done
    await waitForMilliseconds(this.time, 300);
    const finalWidth = window.innerWidth;
    const finalHeight = window.innerHeight;
    if (finalWidth !== width || finalHeight !== height) {
      this.game.scale.resize(finalWidth, finalHeight);
    }
  }

  shutdown() {}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
